<ul class="tabrow">
    <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [ngClass]="tab.active ? 'active' : ''">
        {{tab.tabTitle}}
    </li>
</ul>
<ng-content></ng-content>